module.exports = __webpack_public_path__ + "media/images/communities/logos/eajc-bf86fc13e48ede7207d80a3dbd692312.png";